import { ApolloProvider } from "@apollo/client";
import React from "react";
import ReactDOM from "react-dom";
import "react-phone-number-input/style.css";
import { Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { client } from "./Utils/Apollo/apolloClient";
import { sendEvent } from "./Utils/GoogleAnalytics/analytics";
import { history } from "./Utils/Router/browserHistory";
import "./index.less";
import { PermissionProvider } from "./Utils/Context/permissionContext";

ReactDOM.render(
  <ApolloProvider client={client}>
    <PermissionProvider>
      <Router history={history}>
        <App />
      </Router>
    </PermissionProvider>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToAnalytics);

function sendToAnalytics({ id, name, value }) {
  sendEvent({
    eventCategory: "Web Vitals",
    eventAction: name,
    eventValue: Math.round(name === "CLS" ? value * 1000 : value), // values must be integers
    eventLabel: id, // id unique to current page load
    nonInteraction: true, // avoids affecting bounce rate
  });
}
